import { InjectionToken } from '@angular/core';

export interface ILocalizationOptions {
  folderPrefix: string | string[];
  fileSuffix: string;
}

export const LOCALIZATION_OPTIONS = new InjectionToken<ILocalizationOptions>('ILocalizationOptions');
